import { useContext } from 'react';
import { ViewerContext } from '../context';

export function useViewer() {
  const context = useContext(ViewerContext);
  return { ...context };
}
